import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    educationDetails : [],
    jobDetails : [],
    socialMediaDetails: [],
    otherDetails : [],
}

const fresherProfileSlice = createSlice({
    name: "fresherProfile",
    initialState,
    reducers: {
        addEducation : (state, action) => {
            state.educationDetails.push(action.payload);
        },
        addJob : (state, action) => {
            state.jobDetails.push(action.payload);
        },
        addSocialMedia : (state, action) => {
            state.socialMediaDetails.push(action.payload);
        },
        addOthers : (state, action) => {
            state.otherDetails.push(action.payload);
        },
        resetProfile: () => initialState,
    },
});

export const {
    addEducation,
    addJob,
    addSocialMedia,
    addOthers,
    resetProfile,
} = fresherProfileSlice.actions;

export default fresherProfileSlice.reducer;